import {useEffect, useState} from "react";
import PropTypes from 'prop-types';

export default function TitledName(props) {
	const [title, setTitle] = useState(props.title || '');

	useEffect(() => {
		setTitle(props.title)
	}, [props.title]);

	const CustomTitle = `h${props.level || 4}`;

	return (
		<CustomTitle className={props.className}>
			{
				title && title
				.split(' | ')
				.map((el, i) => <span key={i}>{el}&nbsp;</span>)
			}
		</CustomTitle>
	)
}

TitledName.propTypes = {
	title: PropTypes.string.isRequired,
	level: PropTypes.number,
	className: PropTypes.string,
}